import PropTypes from "prop-types"
import React, { Fragment, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { toggleAddSoloPositionDialog } from "../../../../actions/billingDialogs"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@material-ui/core"

import useStyles from "./styles"
import {
  CircularProgress,
  Typography,
} from "../../../../../node_modules/@material-ui/core/index"
import LoadingButton from "../../../LoadingButton/index"
import AutocompleteBilling from "../../Common/AutocompleteBilling/index"
import { getParentChildRoles } from "../../../../actions/roles"

const AddSoloPositionDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const open = useSelector(
    state => state.billingDialogs.addSoloPositionDialogOpen
  )
  const data = useSelector(state => state.billingDialogs.data)
  const createFunc = data && data.func

  const childParentRoles = useSelector(state => state.misc.childParentRoles)
  const [loading, setLoading] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [parentRolesSuggestion, setParentRolesSuggestion] = useState([])
  const [selectedParentRole, setSelectedParentRole] = useState(null)
  const [childRoles, setChildRoles] = useState([])
  const [selectedChildRole, setSelectedChildRole] = useState(null)

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  useEffect(
    () => {
      setLoading(true)
      if (childParentRoles === null && open) {
        dispatch(getParentChildRoles())
          .then(res => {
            setLoading(false)
          })
          .catch(err => {
            setLoading(false)
          })
      }
    },
    [open]
  )

  useEffect(
    () => {
      if (childParentRoles) {
        let newArray = []
        childParentRoles.parents.map(
          p =>
            childParentRoles.connections.find(x => x.parent_role_id === p.id) &&
            newArray.push({ id: p.id, name: p.name, rate: null })
        )
        setParentRolesSuggestion(newArray)
      }
    },
    [childParentRoles]
  )

  const handleClose = () => {
    setSelectedParentRole(null)
    setChildRoles([])
    setSelectedChildRole(null)
    setConfirmLoading(false)
    dispatch(toggleAddSoloPositionDialog(false))
  }

  const createPosition = () => {
    setConfirmLoading(true)
    createFunc(selectedChildRole, handleClose)
  }

  const selectParentRole = id => {
    const selected = parentRolesSuggestion.find(x => x.id === id)
    let child = childParentRoles.connections
      .map(
        x =>
          x.parent_role_id === id
            ? childParentRoles.children.find(y => x.child_role_id === y.id)
            : null
      )
      .filter(el => el != null)
    setChildRoles(child)

    let roleNames = []
    child && child.map(c => roleNames.push(c.name))
    setSelectedParentRole(selected)
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h3">Add Role </Typography>
      </DialogTitle>
      <DialogContent>
        {loading && parentRolesSuggestion.length === 0 ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : (
          <Fragment>
            <AutocompleteBilling
              placeholder="Search Parent Role"
              getOptionLabel={option => option.name}
              value={selectedParentRole}
              className={classes.autocomplete}
              labelKey="name"
              blurInputOnSelect
              backspaceRemovesValue
              showValue
              options={parentRolesSuggestion}
              caps
              onChange={value => {
                selectParentRole(value.id)
                setSelectedChildRole(null)
              }}
            />
            <Box marginTop="50px">
              <AutocompleteBilling
                disabled={childRoles.length === 0}
                placeholder="Search Role"
                getOptionLabel={option => option.name}
                value={selectedChildRole}
                className={classes.autocomplete}
                labelKey="name"
                blurInputOnSelect
                backspaceRemovesValue
                showValue
                options={childRoles}
                caps
                onChange={value => {
                  setSelectedChildRole(value)
                }}
              />
            </Box>
          </Fragment>
        )}
      </DialogContent>
      <DialogActions className={classes.buttons}>
        <LoadingButton
          size={viewportWidth > 600 ? "medium" : "small"}
          variant="outlined"
          color="primary"
          className={classes.button}
          onClick={handleClose}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          size={viewportWidth > 600 ? "medium" : "small"}
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={createPosition}
          disabled={selectedChildRole === null}
        >
          {confirmLoading ? (
            <CircularProgress size={22} style={{ color: "#fff" }} />
          ) : (
            "Confirm"
          )}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

AddSoloPositionDialog.propTypes = {
  children: PropTypes.node,
}

export default AddSoloPositionDialog
